module.exports = __webpack_public_path__ + "img/digitalIdentity21.1e82cebf.png";